import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Registro_bienesComponent = /** @class */ (function () {
    function Registro_bienesComponent(_formService, fb) {
        this._formService = _formService;
        this.fb = fb;
        this.rows = [];
        this.form = new FormGroup({
            inscrito: new FormControl(''),
            numero: new FormControl('', [Validators.min(0), Validators.pattern(/[0-9]*/)]),
            anio: new FormControl('', [Validators.min(1850), Validators.max(new Date().getFullYear()), Validators.pattern(/[0-9]*/)]),
            bienes: new FormControl(''),
        });
        if (!JSON.parse(localStorage.getItem("registro_bienes"))) {
            localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("registro_bienes"));
            this.form.controls['inscrito'].setValue(this.rows[0] ? this.rows[0].inscrito : '');
            this.form.controls['numero'].setValue(this.rows[0] ? this.rows[0].numero : '');
            this.form.controls['anio'].setValue(this.rows[0] ? this.rows[0].anio : '');
            this.form.controls['bienes'].setValue(this.rows[0] ? this.rows[0].bienes : '');
        }
    }
    Registro_bienesComponent.prototype.add_registro = function () {
        localStorage.setItem("registro_bienes", JSON.stringify([]));
        this.actualRow = localStorage.getItem("registro_bienes");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            inscrito: this.form.value.inscrito,
            numero: this.form.value.numero,
            anio: this.form.value.anio,
            bienes: this.form.value.bienes
        });
        localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
        console.log(this.registro_bienes);
    };
    Registro_bienesComponent.prototype.delete_registro = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("registro_bienes", JSON.stringify(this.rows));
            }
        }
    };
    return Registro_bienesComponent;
}());
export { Registro_bienesComponent };
